<template>
  <section class="why-choose-section">
    <div class="section-container">

      <div class="header">
        <div class="tag">+ CAPABILITY ASSESSMENT</div>
        <h2 class="title">Why Choose <span class="gradient">Fraud Counsel Department</span></h2>

        <div class="divider-container">
          <div class="line"></div>
          <span class="square-icon">[■]</span>
          <div class="line"></div>
        </div>
      </div>

      <div class="grid">
        <div v-for="(item, index) in reasons" :key="index" class="card">
          <div class="icon-box">
            <span class="icon">{{ item.icon }}</span>
          </div>
          <h3 class="card-title">{{ item.title }}</h3>
          <p class="card-desc">{{ item.desc }}</p>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'WhyChooseSection',
  data() {
    return {
      reasons: [
        {
          icon: '🔍',
          title: 'Advanced Blockchain Intelligence',
          desc: 'We deploy cutting-edge blockchain analytics to trace stolen assets across multiple networks, wallets, and exchange layers with surgical precision.'
        },
        {
          icon: '🛡️',
          title: 'Evidence-Based Methodology',
          desc: 'Every case is handled with a strict evidence-first approach — documentation, chain of custody, and forensic integrity are maintained throughout the entire process.'
        },
        {
          icon: '⚖️',
          title: 'Legal Enforcement Alignment',
          desc: 'We work directly with international law enforcement, cybercrime units, and regulatory bodies to strengthen recovery outcomes for every client we serve.'
        },
        {
          icon: '🌐',
          title: 'Global Cross-Border Reach',
          desc: 'Our international network allows us to pursue criminals across jurisdictions — wherever the blockchain trail leads, our team will follow it without exception.'
        },
        {
          icon: '🔒',
          title: 'Strict Confidentiality',
          desc: 'All case data, communications, and evidence are encrypted and handled under the highest data-protection standards. Your privacy is fully guaranteed at every stage.'
        },
        {
          icon: '⏱️',
          title: '24/7 Case Monitoring',
          desc: 'Our operations centre monitors blockchain activity around the clock, providing real-time updates and instant response when critical evidence emerges during your case.'
        }
      ]
    };
  }
}
</script>

<style scoped>
.why-choose-section {
  background-color: #070b14;
  padding: 60px 5%;
  color: #e2e8f0;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
}

.header {
  margin-bottom: 50px;
}

.tag {
  color: #4fd1c5;
  font-size: 0.75rem;
  letter-spacing: 2px;
  margin-bottom: 10px;
  font-weight: 500;
}

.title {
  font-size: 2.6rem;
  font-weight: 700;
  margin: 0 0 20px;
}

.gradient {
  background: linear-gradient(90deg, #4fd1c5, #8be9fd);
  -webkit-background-clip: text;
  color: transparent;
}

.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(79, 209, 197, 0.2);
}

.divider-container .square-icon {
  color: #4fd1c5;
  font-size: 0.8rem;
  font-family: monospace;
  margin: 0 15px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.card {
  background: rgba(13, 17, 23, 0.8);
  border: 1px solid #253045;
  border-radius: 8px;
  padding: 30px 25px;
  transition: all 0.3s ease;
}

.card:hover {
  border-color: #4fd1c5;
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(79, 209, 197, 0.1);
}

.icon-box {
  width: 50px;
  height: 50px;
  background: #0a101f;
  border: 1px solid #253045;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
}

.icon {
  font-size: 1.5rem;
}

.card-title {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0 0 15px;
  color: #ffffff;
}

.card-desc {
  color: #94a3b8;
  font-size: 0.9rem;
  line-height: 1.7;
  margin: 0;
}

@media (max-width: 1200px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 2.2rem;
  }

  .grid {
    grid-template-columns: 1fr;
  }
}
</style>